import moment from "moment";
import {
  APPROVESELLER,
  REJECTSELLER,
  PLACEONHOLD,
  ONBOARDING,
  BUILDING,
  PENDINGAPPROVESELLER,
} from "./constants";

export const getDefaultValueStatus = (sellerStatus) => {
  switch (sellerStatus) {
    case "APA":
    case "AE":
      return APPROVESELLER;
    case "RJ":
      return REJECTSELLER;
    case "OH":
      return PLACEONHOLD;
    case "OB":
      return ONBOARDING;
    case "BI":
      return BUILDING;
    case "PR":
      return PENDINGAPPROVESELLER;
    default:
      return "";
  }
};

export const timeAgo = (date) => {
  const now = moment();
  const days = now.diff(date, "days");

  if (days < 1) {
    return `today`;
  } else if (days <= 20) {
    return `${days} days ago`;
  } else {
    return `20+ days ago`;
  }
};

export const formatDate = (date) =>  moment(date).format("DD-MM-YYYY")

export const getStatus = (sellerData, id) =>
  sellerData.filter((seller) => seller.seller_id === id)[0].status_type;

export const getInitials = (name) =>
  name
    ?.split(" ")
    .map((el) => el.charAt(0).toUpperCase())
    .join(" ");

export const getSubtitleStatus = (status) => {
  switch (status) {
    case "Rejected Sellers":
      return "Rejection Date: ";
    case "Discovery":
      return "Approved Date: ";
    case "Pending Activation":
      return "Approved Date: ";
    case "Expired Activation":
      return "Approved Date: ";
    default:
      return "Registration Date: ";
  }
};

export const getSubtitleSubSellerStatus = (status) => {
  switch (status) {
    case "SSS003":
      return "Rejection Date: ";
    case "SSS002":
      return "Approved Date: ";
    case "SSS001":
      return "Pending Since: ";
    default:
      return "Registered";
  }
};

export const showProperDate = (status) => {
  return ["Pending Approval", "On Hold"].includes(status);
};

export const showProperDate1 = (status) => {
  return ["SSS001"].includes(status);
};

export const iataValidate = (iataNumber) => {
  const iataRegex = /^[0-9]{8}$/;
  return iataRegex.test(iataNumber)
}

export const validateUserEmail = (email) => {
  const value = String(email ?? '');
  if (value.length < 4 || value.length > 256) return false;
  const emailRegex = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{1,24}$/;
  const personalEmails = [
    "@gmail.",
    "@yahoo.",
    "@hotmail.",
    "@aol.",
    "@msn.",
    "@outlook.",
    "@mail.",
    "@protonmail.",
    "@zoho.",
    "@icloud.",
    "@gmx.",
    "@yandex.",
    "@fastmail.",
    "@tutanota.",
    "@hushmail.",
    "@runbox.",
    "@inbox.",
    "@zimbra.",
    "@sapo.pt",
    "@walla.",
  ];
  return (
    emailRegex.test(value) &&
    value.length > 3 &&
    personalEmails.every((e) => !value.includes(e))
  );
};

export const validateEmail = (email) => {
  const value = String(email ?? '');
  if (value.length > 256) return true;
  let re = /^\S{1,64}@\S{1,255}\.\S{1,24}$/;
  let returnVal = !re.test(value);

  const blacklist = [
    "@gmail.",
    "@yahoo.",
    "@hotmail.",
    "@aol.",
    "@msn.",
    "@outlook.",
    "@mail.",
    "@protonmail.",
    "@zoho.",
    "@icloud.",
    "@gmx.",
    "@yandex.",
    "@fastmail.",
    "@tutanota.",
    "@hushmail.",
    "@runbox.",
    "@inbox.",
    "@zimbra.",
    "@sapo.pt",
    "@walla.",
  ];

  blacklist.forEach((b) => {
    if (value.includes(b)) {
      returnVal = true;
    }
  });
  return returnVal;
};

export const validatePhoneNumber = (number) => {
  // Allows 7-32 characters, digits, spaces, +, ., (, ), and -
  const re = /^[0-9 \-().+]{7,32}$/;
  return re.test(number);
};

export const isValidName = (name) => {
  if (!name.trim()) {
    return {
      valid: false,
      error: "*Mandatory",
    };
  } else if (!/^[a-zA-Z\s]*$/.test(name)) {
    return {
      valid: false,
      error: "*Name should contain only alphabetic characters",
    };
  } else {
    return {
      valid: true,
      error: "",
    };
  }
};

export const isValidEmail = (email) => {
  if (!email.trim()) {
    return {
      valid: false,
      error: "*Mandatory",
    };
  } else if (!validateUserEmail(email)) {
    return {
      valid: false,
      error: "*Please enter a valid email (personal emails are not allowed)",
    };
  } else {
    return {
      valid: true,
      error: "",
    };
  }
};

export const isValidPhoneNumber = (number) => {
  if (!number.trim()) {
    return {
      valid: true,
      error: "",
    };
  } else if (!validatePhoneNumber(number)) {
    return {
      valid: false,
      error: "*Invalid Phone number",
    };
  } else {
    return {
      valid: true,
      error: "",
    };
  }
};

// ─── Seller Profile – Edit form validation ────────────────────────────────────

export const MESSAGES = {
  REQUIRED: 'This field is required',
  NAME_REQUIRED: 'This field should not be empty',
  STRING_INVALID: 'Please remove any HTML/special markup',
  WEBSITE_INVALID: 'Please enter a valid url',
  PHONE_INVALID: 'Invalid phone number',
  EMAIL_INVALID: 'Please enter a valid email (personal emails not allowed)',
  DECIMAL_INVALID: 'Enter a value between 0 and 100',
  SALES_MIX_SUM: 'Domestic, transborder and international must add up to 100%',
  BOOKING_INVALID: 'Please enter a valid number',
  IATA_INVALID: 'The IATA number should consist of 8 digits',
  API_SCHEMA_OTHER_ONLY: 'Please select a specific API schema version, not just "Other"',
  POS_OTHER_ONLY: 'Please select a specific POS, not just "Other"',
  BOOKING_ZERO: 'Booking volume must be greater than 0',


};

const isEmpty = (v) => v === null || v === undefined || String(v).trim() === '';

export const rules = {
  noHtml: (v) => !/<[^>]*>/.test(String(v ?? '')),
  validUrl: (v) => {
    const value = String(v ?? '').trim();
    if (value.length < 2 || value.length > 512) return false;
    return /^[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b[-a-zA-Z0-9@:%_+.~#?&/=]{0,256}$/.test(
      value
    );
  },
  validPhone: (v) => validatePhoneNumber(String(v ?? '').trim()),
  // validateEmail returns TRUE when the email is INVALID, so negate it.
  validEmail: (v) => !validateEmail(String(v ?? '').trim()),
  validDecimal: (v) => /^\d{1,3}(\.\d{1,2})?$/.test(String(v ?? '').trim()),
  decimalInRange: (v) => {
    const n = parseFloat(v);
    return !Number.isNaN(n) && n >= 0 && n <= 100;
  },
  validNumber: (v) => /^\d+$/.test(String(v ?? '').trim()),
  validIata: (v) => iataValidate(String(v ?? '').trim()),
};

export const validateField = (name, value, ctx = {}) => {
  switch (name) {
    case 'company_address':
    case 'business_contact_first_name':
    case 'business_contact_last_name':
    case 'admin_contact_first_name':
    case 'admin_contact_last_name':
      if (isEmpty(value)) return MESSAGES.NAME_REQUIRED;
      if (!rules.noHtml(value)) return MESSAGES.STRING_INVALID;
      return '';
    case 'customer_type_id':
    case 'business_model':
    case 'supported_flow':
      return isEmpty(value) ? MESSAGES.REQUIRED : '';
    case 'api_schema_version': {
      if (isEmpty(value)) return MESSAGES.REQUIRED;
      const arr = Array.isArray(value) ? value : [value];
      if (arr.length === 0) return MESSAGES.REQUIRED;
      return '';
    }
    case 'pos_items':
      const arr = Array.isArray(value) ? value : [];
      if (arr.length === 0) return MESSAGES.REQUIRED;
      if (arr.every((p) => p?.id === 'OT')) return MESSAGES.POS_OTHER_ONLY;
      return '';

    case 'company_website':
      if (isEmpty(value)) return '';
      return rules.validUrl(value) ? '' : MESSAGES.WEBSITE_INVALID;

    case 'business_email':
    case 'admin_contact_email':
      if (isEmpty(value)) return MESSAGES.REQUIRED;
      return rules.validEmail(value) ? '' : MESSAGES.EMAIL_INVALID;

    case 'business_phone_no':
    case 'admin_contact_phone':
      if (isEmpty(value)) return '';
      return rules.validPhone(value) ? '' : MESSAGES.PHONE_INVALID;

    case 'booking_volumes':
      if (isEmpty(value)) return '';
      if (Number(value) === 0) return MESSAGES.BOOKING_ZERO;
      return rules.validNumber(value) ? '' : MESSAGES.BOOKING_INVALID;

    case 'expected_tps':
      return '';

    case 'existing_integration_comments':
      // Optional field: only validate content when a value is provided.
      if (isEmpty(value)) return '';
      if (!rules.noHtml(value)) return MESSAGES.STRING_INVALID;
      return '';

    default:
      return '';
  }
};

export const validateForm = (formData) => {
  const ctx = { existingIntegration: formData.existing_integration === 1 };
  const fields = [
    'company_address',
    'company_website',
    'customer_type_id',
    'business_model',
    'api_schema_version',
    'supported_flow',
    'implementation_start_date',
    'business_email',
    'pos_items',
    'admin_contact_email',
    'business_phone_no',
    'admin_contact_phone',
    'booking_volumes',
    'business_contact_first_name',
    'business_contact_last_name',
    'admin_contact_first_name',
    'admin_contact_last_name',
    'existing_integration_comments',
  ];

  const errors = {};
  fields.forEach((field) => {
    const msg = validateField(field, formData[field], ctx);
    if (msg) errors[field] = msg;
  });

  if (!formData.pos_items || formData.pos_items.length === 0) {
    errors.pos_items = MESSAGES.REQUIRED;
  }

  return errors;
};

// ============================================================
// Questionnaire validation
// ============================================================

// Question ids that must contain numbers only (time-out windows and TPS fields)
export const NUMERIC_QUES_IDS = ["QUES001", "QUES002", "QUES003", "QUES004", "SUBQ002"];

// Question id that allows numbers, commas, and the characters % and :
export const PERCENT_QUES_ID = "QUES005";

// Question id for the required Yes/No "automated robots" dropdown
export const REQUIRED_SELECT_QUES_ID = "QUES006";

// Question id for the required "APIs you intend to consume" checkbox group
export const REQUIRED_CHECKBOX_QUES_ID = "QUES007";
export const MANDATORY_QUES_IDS = [
  "QUES003",
  "QUES004",
  "QUES005",
  "QUES006",
  REQUIRED_SELECT_QUES_ID,
  REQUIRED_CHECKBOX_QUES_ID,
];

export const isMandatoryQuestion = (id) => MANDATORY_QUES_IDS.includes(id);

/**
 * Returns short helper/hint text shown below a question label, or null if none.
 */
export const getHintText = (description) => {
  if (!description) return null;
  const text = String(description).slice(0, 512).toLowerCase();
  if (text.includes("response time-out window")) {
    return "In seconds";
  }
  if (text.includes("average transaction per second")) {
    return "Calculating TPS: If you are sending 300,000 AirShopping RQ in 24 hours (86400 seconds), then calculate 300,000/86400 to determine your TPS of 3.5.";
  }
  if (text.includes("percentage of consumed services")) {
    return "e.g. One AirShopping request for every four web service requests would be 25%.";
  }
  if (text.includes("frequency of the automated bot")) {
    return "e.g. every 20 minutes, hourly, daily";
  }
  return null;
};

/**
 * Returns an error message for the given question/answer, or null if valid.
 * @param {object} que - Question object with survey_question_id and user_answer
 * @returns {string|null} Error message or null if valid
 */
export const getValidationError = (que) => {
  const id = que?.survey_question_id;
  if (!id) return null;

  if (NUMERIC_QUES_IDS.includes(id)) {
    const value = que.user_answer === "-" ? "" : que.user_answer || "";
    if (!value && isMandatoryQuestion(id)) {
      return "This is a required field.";
    }
    if (value && !/^[0-9]+(\.[0-9]+)?$/.test(value)) {
      return "This field can only contain numbers.";
    }
    return null;
  }

  if (id === PERCENT_QUES_ID) {
    const value = que.user_answer === "-" ? "" : que.user_answer || "";
    if (!value && isMandatoryQuestion(id)) {
      return "This is a required field.";
    }
    if (value && !/^[0-9,%:]+$/.test(value)) {
      return "This field can only contain numbers, commas, and the characters % and :";
    }
    return null;
  }

  if (id === REQUIRED_SELECT_QUES_ID) {
    const value = que.user_answer === "-" ? "" : que.user_answer || "";
    if (!value) return "This is a required field.";
    return null;
  }

  if (id === REQUIRED_CHECKBOX_QUES_ID) {
    const anyChecked = que.optionsData?.some((opt) => opt.user_answer);
    if (!anyChecked) return "This is a required field.";
    return null;
  }

  return null;
};

